// extracted by mini-css-extract-plugin
module.exports = {"menu-container":"index-module_menu-container_37ffD","menu-item":"index-module_menu-item_3jyPy","delete":"index-module_delete_2kOS7"};